<template>
  <v-file-input
    :value="value"
    outlined
    hide-details
    prepend-icon=""
    class="rmr-input rmr-file-input"
    :class="{ 'rmr-input--md': size === 'md' }"
    :prepend-inner-icon="resolvedIcon"
    v-bind="$attrs"
    v-on="listeners"
  />
</template>

<script>
import { mdiPaperclip } from "@mdi/js";

export default {
  name: "RmrFileInput",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [File, Array, Object, String, null],
      default: null,
    },
    icon: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md"].includes(v),
    },
  },
  computed: {
    resolvedIcon() {
      return this.icon || mdiPaperclip;
    },
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => this.$emit("input", value),
        change: (value) => {
          this.$emit("input", value);
          this.$emit("change", value);
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_rmr-input.scss";

.rmr-file-input {
  ::v-deep .v-input__slot {
    background: $rmr-surface-0 !important;
    box-shadow: inset 0 0 0 1px $rmr-border-hover;
    transition: box-shadow 0.18s ease, transform 0.18s ease !important;
  }

  ::v-deep .v-input__slot fieldset {
    border-color: transparent !important;
  }

  ::v-deep .v-label {
    top: 13px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: $rmr-text-secondary !important;
  }

  ::v-deep .v-label.v-label--active {
    top: 18px !important;
    background: $rmr-surface-0;
    padding: 0 4px;
    margin-left: -4px;
    border-radius: $rmr-radius-xs;
  }

  ::v-deep .v-text-field__slot input,
  ::v-deep .v-file-input__text {
    font-size: 13px !important;
    color: $rmr-text-primary !important;
    align-self: center !important;
  }

  ::v-deep .v-file-input__text {
    display: flex !important;
    align-items: center !important;
    min-height: 20px;
    padding-top: 0;
  }

  ::v-deep .v-input__prepend-inner {
    margin-top: 0 !important;
    align-self: center !important;
  }

  ::v-deep .v-input__prepend-inner .v-icon {
    color: $rmr-indigo !important;
  }

  ::v-deep .v-input__append-inner {
    margin-top: 0 !important;
    align-self: center !important;
  }

  ::v-deep .v-input__append-inner .v-icon {
    color: $rmr-text-subtle !important;
  }

  &.v-input--is-focused {
    ::v-deep .v-input__slot {
      box-shadow: inset 0 0 0 1px rgba($rmr-indigo, 0.22), 0 0 0 4px rgba($rmr-indigo, 0.08) !important;
      transform: translateY(-1px);
    }
  }
}
</style>
